var render = function render(){var _vm=this,_c=_vm._self._c;return _c('absence-page',{attrs:{"group":"vacation"}})
}
var staticRenderFns = []

export { render, staticRenderFns }